<div class="dxc-field__wrap">
  <span class="dxc-field__icon dxc-field__icon--left">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      <circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>
    </svg>
  </span>
  <input #field class="dxc-input dxc-input--with-icon" role="combobox" autocomplete="off"
    [attr.id]="inputId || null"
    [class.is-invalid]="invalid" [placeholder]="placeholder" [value]="text" [disabled]="disabled"
    [attr.aria-expanded]="open" [attr.aria-label]="ariaLabel || null"
    [attr.aria-activedescendant]="activeDescendant"
    (input)="onInput($any($event.target).value)" (focus)="open = true" (keydown)="onKeydown($event)">
  <!-- `aria-hidden`: el lector ya no necesita el cartel —llega al campo con el
       tabulador— y leído en voz alta «⌘K» es ruido delante de la etiqueta. -->
  @if (shortcutHint) { <span class="dxc-kbd" aria-hidden="true">{{ shortcutHint }}</span> }
</div>

@if (open && text.trim().length >= minChars) {
  <ul class="dxc-combo__panel" role="listbox"
    [class.dxc-combo__panel--up]="panelUp" [style]="panelStyle">
    @if (loading) {
      <li class="dxc-combo__empty" style="display:flex;align-items:center;justify-content:center;gap:9px">
        <span class="dxc-spinner" style="color:var(--dxc-accent)"></span>Consultando…
      </li>
    } @else {
      @for (option of results; track option.value; let i = $index) {
        <li>
          <button type="button" class="dxc-combo__option" role="option" [attr.id]="optionId(i)"
            [class.dxc-combo__option--active]="i === activeIndex"
            (mousedown)="$event.preventDefault()" (mouseenter)="activeIndex = i" (click)="choose(option)">
            <span class="dxc-combo__check"></span>
            <span class="dxc-combo__option-label">{{ option.label }}</span>
            @if (option.meta) { <span class="dxc-combo__option-meta">{{ option.meta }}</span> }
          </button>
        </li>
      }
      <!-- Con `createLabel`, la fila de crear sustituye al «No encontramos»: ya
           dice qué nombre se va a registrar. -->
      @if (!results.length && !showCreate) {
        <li class="dxc-combo__empty">No encontramos «{{ text.trim() }}»</li>
      }
      @if (showCreate) {
        <li>
          <button type="button" class="dxc-combo__option dxc-combo__option--create" role="option"
            [attr.id]="optionId(createIndex)"
            [class.dxc-combo__option--active]="activeIndex === createIndex"
            (mousedown)="$event.preventDefault()" (mouseenter)="activeIndex = createIndex" (click)="onCreate()">
            <span class="dxc-combo__check">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
            </span>
            <span class="dxc-combo__option-label">{{ createLabel }} «{{ term }}»</span>
          </button>
        </li>
      }
    }
  </ul>
} @else if (open && text.trim().length > 0) {
  <div class="dxc-field__hint" style="margin-top:6px">Escribe al menos {{ minChars }} caracteres.</div>
}
